export enum VoucherCatgCode {
    MERCHANT = "MERCHANT",
    ODARING = "ODARING", 
    MEMBERSHIP = "MEMBERSHIP", 
}
  